// 选项卡——主流程
const MainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `module/tab/index${i + 1}`,
  name: `module/tabIndex${i + 1}`,
  component: () => import(`@/views/recognize/module/tab/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 选项卡——主流程，开始
    ...MainRoutes
  ]
}
